import React from 'react'
import PropTypes from 'prop-types'
import styled, { theme, prop } from '@nobia/zeus-components/lib/styled'

import { Icon } from '../icons'
import { formatPrice } from '../cards/utils'
import { getMonthlyPayment, getMonthlyPaymentShortVersion, hasMonthlyPayment, hasFullVersion } from '../../brands/monthsToPay'
import { useTranslation } from '../../utils/useTranslation'

const Wrapper = styled.div`
  background-color: '${p => p.theme.section.bgColor};'
  color: ${p => p.theme.section.color};
  padding: 10px ${prop('theme.body.padding')};
  pointer-events: ${p => (p.hasMonthlyPayment ? 'auto' : 'none')};
  cursor: pointer;
  font-family: ${prop('theme.font.paragraph.fontFamily')};
  font-size: 16px;
  border-bottom: 1px solid #c2bcb8;
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    padding: 10px 0;
    border-bottom: none;
  }
  @media (min-width: ${prop('theme.body.desktopWidth')}) {
    margin-left: 100px;
  }
  @media (min-width: 1300px) {
    margin-left: 110px;
  }
`

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    justify-content: left;
  }
`

const Column = styled.div`
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    display: flex;
    align-items: center;
  }
`
const P = styled.p`
  text-align: left;
  margin: 0 7px 0 0;
  font-size: ${prop('theme.costSummary.totalCost.fontSize')};
`
const Cost = styled(P)`
  margin: 0 15px 0 0;
`
const Strong = styled.strong`
  font-size: ${prop('theme.costSummary.totalCost.fontSize')};
  font-weight: 700;
`
const MonthlyPayment = styled(Strong)`
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    display: none;
  }
`

const LinkRow = styled(Row)`
  z-index: 2;
  pointer-events: auto;
  cursor: pointer;
  @media (max-width: ${prop('theme.body.tabletWidth')}) {
    display: none;
  }
`

const Link = styled.a`
  text-decoration: underline;
  color: ${theme('colors.button')};
`

const CostSummary = ({ summary, months, setShowModal, financeId }) => {
  const { t, country } = useTranslation()

  return (
    <Wrapper hasMonthlyPayment={hasMonthlyPayment}>
      <Row onClick={() => setShowModal(true)}>
        <Column>
          <P>{t('app.components.cost-summary.title')}</P>      
          <Cost>
            <Strong>{formatPrice({ price: summary, country })}</Strong>
            {hasMonthlyPayment && (
              <>
                {' '}
                {t('app.components.cost-summary.alternative')}{' '}
                <MonthlyPayment>
                {hasFullVersion ? (
                    <>
                      {formatPrice({
                        price: getMonthlyPayment(summary, months, financeId),
                        country,
                        digits: 2,
                      })}{' '}
                    </>
                    ):(
                    <>
                      {formatPrice({
                        price: getMonthlyPaymentShortVersion(summary),
                        country,
                       })}
                    </>
                    )}
                  {t('app.components.cost-summary.per-month')}
                </MonthlyPayment>
              </>
            )}
          </Cost>
        </Column>
        {hasMonthlyPayment && hasFullVersion && <Icon name="info" />}
      </Row>
      {!hasMonthlyPayment && (
        <LinkRow>
          <Link
            href={t('app.finance.terms-and-conditions.link')}
            target="_blank"
          >
            {t('app.finance.terms-and-conditions.description')}
          </Link>
        </LinkRow>
      )}
    </Wrapper>
  )
}

CostSummary.propTypes = {
  financeId: PropTypes.string.isRequired,
  summary: PropTypes.number.isRequired,
  months: PropTypes.shape({
    months: PropTypes.number.isRequired,
  }).isRequired,
  setShowModal: PropTypes.func.isRequired,
}

export default CostSummary
